// Soera's leren (0048, golf 7; docs/onderzoek/soera-leren.md §4.5 en §4.8). Handgeschreven zoals
// groeiSchool.ts en gelijk aan de API (apps/api/src/routes/v1/app/memorize.ts);
// openapi.contract.test.ts bewaakt elke aanroep. Alleen de ouderapp; de kiosk gebruikt dit nooit.
const id = (v) => encodeURIComponent(v);
export function createMemorizeClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const del = (path) => t.request('DELETE', path);
    return {
        /** Overzicht (namen in de taal van de app). */
        overview: (locale) => get(locale ? `/v1/app/memorize?locale=${encodeURIComponent(locale)}` : '/v1/app/memorize'),
        enable: (input) => post('/v1/app/memorize/enable', input),
        settings: (input) => put('/v1/app/memorize/settings', input),
        items: (items, version) => put('/v1/app/memorize/items', { items, version }),
        preset: (preset, version) => post('/v1/app/memorize/items/preset', { preset, version }),
        member: (memberId, enabled) => put(`/v1/app/memorize/members/${id(memberId)}`, { enabled }),
        giveConsent: (memberId, textVersion, locale) => post(`/v1/app/memorize/members/${id(memberId)}/consent`, {
            action: 'give',
            text_version: textVersion,
            locale,
            accepted: true,
        }),
        withdrawConsent: (memberId) => post(`/v1/app/memorize/members/${id(memberId)}/consent`, {
            action: 'withdraw',
        }),
        act: (input) => post('/v1/app/memorize/progress', input),
        reviewRound: (memberId, items) => post('/v1/app/memorize/review-round', { member_id: memberId, items }),
        milestoneSeen: (memberId, milestone) => post(`/v1/app/memorize/milestones/${id(memberId)}/${id(milestone)}/seen`),
        /** Alles wissen (step-up); verdiende punten blijven. */
        wipe: () => del('/v1/app/memorize'),
    };
}
//# sourceMappingURL=memorize.js.map